<template>
  <div class="content">
    <el-card>
      <el-result icon="success" title="成功提示" subTitle="恭喜您，预约成功">
        <template slot="extra">
          <p class="title">您已成功预约业务，请按时携带相关材料到指定预约地点办理相关业务</p>
          <p class="title">请在预约查询查看预约详情</p>
          <div class="text-content">
            <p>预约号: <span>{{busi.busiCode}}</span></p>
            <p>预约事项: <span>{{busi.projectName}}</span></p>
            <p>预约时间： <span>{{busi.rDate}} {{busi.timeRange}}</span></p>
            <p>办理大厅： <span>{{busi.hallName}}</span></p>
            <p><span v-html="hall.rnote"></span></p>
          </div>
          <el-button type="primary" size="medium" @click="back">返回</el-button>
        </template>
      </el-result>
    </el-card>
  </div>
</template>

<script>
import {getBusiInfo} from "@/api/busi";
import {getHallInfo} from "@/api/hall";
import wasm from "@/mixins/wasm";

export default {
  name: "result",
  mixins: [wasm],
  async mounted() {
    await this.initwasm().then(() => {
      this.getBusiInfo()
    })
  },
  data() {
    return {
      busi: {},
      hall: {}
    }
  },
  methods: {
    back() {
      this.$parent.backDashboard()
    },
    getHallInfo(hallId) {
      let data = {
        hallId: hallId,
      }
      getHallInfo(data).then(res => {
        this.hall = res.data.info
      })
    },
    getBusiInfo() {
      let data = {
        busiId: this.$store.state.busi.busiId
      }
      getBusiInfo(data).then(res => {
        this.busi = res.data.info
        this.getHallInfo(this.busi.hallId)
      })
    }
  }
}
</script>

<style scoped lang="less">
.content {
  padding: 20px;
}

.title {
  padding: 10px 0;
  color: #9C9FAA;
  display: flex;
  align-items: center;
  justify-content: center;
}

.text-content {
  text-align: left;
  background: #FAFAFB;
  padding: 20px;
  margin: 10px 0;

  p {
    color: #131C3399;
    padding: 10px 0;

    span {
      color: #42444D;
    }
  }
}
</style>
